import * as M from '@mantine/core';
import useGetDeviceAggregation from '../hooks/useGetDeviceAggregation';

interface IPropsDeviceSummary {
  onClickExpiredSoonSummary: () => void;
}

export default function DeviceSummary(props: IPropsDeviceSummary) {
  const { onClickExpiredSoonSummary } = props;

  const { data } = useGetDeviceAggregation();

  return (
    <M.Box p="md" mb="md" bg="gray.0">
      <M.Flex justify="space-around" align="center">
        <M.Box>
          <M.Text ta="center" size="sm" mb={4} fw={500}>
            등록된 총 디바이스
          </M.Text>
          <M.Text ta="center" fw={700}>
            {data?.totalDeviceCount ?? 0}
          </M.Text>
        </M.Box>
        <M.Box>
          <M.Text ta="center" size="sm" mb={4} fw={500}>
            신규 등록 (최근 7일)
          </M.Text>
          <M.Text ta="center" fw={700}>
            {data?.recentRegisteredDeviceCount ?? 0}
          </M.Text>
        </M.Box>
        <M.Box onClick={onClickExpiredSoonSummary} style={{ cursor: 'pointer' }}>
          <M.Text ta="center" size="sm" mb={4} fw={500}>
            서비스 만료 예정 (14일 전)
          </M.Text>
          <M.Text ta="center" fw={700} c="secondary.5">
            {data?.expiringSoonDeviceCount ?? 0}
          </M.Text>
        </M.Box>
      </M.Flex>
    </M.Box>
  );
}
